import { LightBackgroundPage } from '@/shared/PublicPage/CustomBgPublicPage.styled';
import PublicPage from '@/shared/PublicPage/PublicPage';
import { Title } from '@/shared/Typography';
import { StyledBlogItem } from './BlogItem.styled';
import Dates from '@/constants/Dates';
import Image from 'next/legacy/image';
import dayjs from 'dayjs';

export default function BlogItem({ blogItem }) {
  return (
    <PublicPage StyledPublicPage={LightBackgroundPage}>
      <StyledBlogItem>
        <div className="blog-item">
          <div className="blog-title">
            <Title>{blogItem.title}</Title>
            <div className="blog-date">
              {dayjs(blogItem.createdAt).format(Dates.defaultFormat)}
            </div>
          </div>
          {blogItem.image ? (
            <div className="image-container">
              <Image
                src={blogItem.image}
                alt={blogItem.title}
                layout="fill"
                objectFit="contain"
              />
            </div>
          ) : null}
          {blogItem.description ? (
            <div
              className="description"
              dangerouslySetInnerHTML={{
                __html: blogItem.description,
              }}
            ></div>
          ) : null}
        </div>
      </StyledBlogItem>
    </PublicPage>
  );
}
